import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../configuration/setup/store";
import { faultCodesApi } from "../../services/faultCodesApi";
import { AlertsPageState, DialogState, VehicleStatusResponse } from "./alertsPageSlideTypes";

const initialState: AlertsPageState = {
	expandedRows: [],
	reloadPage: false,
	openDialogEmail: {
		open: false,
		type: "",
	},
	tableAlertsData: {
		isLoading: false,
		data: {
			data: [],
			total: 0,
		},
	},
	openDialogNotifications: {
		open: false,
		row: {},
	},
};

const alertsPageSlice = createSlice({
	name: "alertsPage",
	initialState,
	reducers: {
		triggerReloadPage: (state) => {
			state.reloadPage = !state.reloadPage;
		},
		setExpandedRows: (state, action: PayloadAction<string[]>) => {
			state.expandedRows = action.payload;
		},
		setTableAlertsData: (state, action: PayloadAction<VehicleStatusResponse>) => {
			state.tableAlertsData.data = action.payload;
		},
		setOpenDialogEmailAlerts: (state, action: PayloadAction<{ open: boolean; type: string }>) => {
			state.openDialogEmail = action.payload;
		},
		setTableAlertsDataLoading: (state, action: PayloadAction<boolean>) => {
			state.tableAlertsData.isLoading = action.payload;
		},
		toggleRowExpansion: (state, action: PayloadAction<string>) => {
			const rowId = action.payload;
			if (state.expandedRows.includes(rowId)) {
				state.expandedRows = state.expandedRows.filter((id) => id !== rowId);
			} else {
				state.expandedRows.push(rowId);
			}
		},
		updateTickets: (state, action) => {
			const { updatedTicket, ids } = action.payload;

			if (Array.isArray(state.tableAlertsData.data.data)) {
				state.tableAlertsData.data?.data?.forEach((infraction: any) => {
					if (ids.includes(infraction.id)) {
						infraction.ticket = updatedTicket;
					}
				});
			}
		},
		setOpenDialogNotifications: (state, action: PayloadAction<DialogState>) => {
			state.openDialogNotifications = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder.addMatcher(faultCodesApi.endpoints.getFaultCodes.matchPending, (state) => {
			state.tableAlertsData.isLoading = true;
		});
		builder.addMatcher(faultCodesApi.endpoints.getFaultCodes.matchFulfilled, (state, { payload, meta }) => {
			state.tableAlertsData.isLoading = false;

			// Get the page number from the request
			const requestPage = meta.arg.originalArgs?.page || 0;

			// If it's the first page, replace the data
			if (requestPage === 0) {
				state.tableAlertsData.data = payload;
			} else {
				// For subsequent pages, append the data
				state.tableAlertsData.data = {
					data: [...state.tableAlertsData.data.data, ...payload.data],
					total: payload.total,
				};
			}
		});
		builder.addMatcher(faultCodesApi.endpoints.getFaultCodes.matchRejected, (state) => {
			state.tableAlertsData.isLoading = false;
		});
	},
});

export const {
	setExpandedRows,
	toggleRowExpansion,
	setTableAlertsDataLoading,
	setOpenDialogNotifications,
	triggerReloadPage,
	setTableAlertsData,
	updateTickets,
	setOpenDialogEmailAlerts,
} = alertsPageSlice.actions;

export const getDialogAlert = (state: RootState) => state.pageAlerts.openDialogNotifications;
export const getPageAlertReload = (state: RootState) => state.pageAlerts.reloadPage;
export const getPageAlertsData = (state: RootState) => state.pageAlerts;
export default alertsPageSlice.reducer;
